module.exports = __webpack_public_path__ + "img/2.959d4406.png";